import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/privacy.css';

const Privacy = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="privacy-page">
      <Header isScrolled={isScrolled} />
      
      {/* Hero Section */}
      <section 
        className="privacy-hero"
        style={{
          background: 'linear-gradient(rgba(21, 21, 20, 0.4), rgba(21, 21, 20, 0.4)), url(/assets/Garbary15.jpg)',
          backgroundSize: '170%',
          backgroundPosition: 'top left'
        }}
      >
        <div className="privacy-hero-content">
          <h1 className="privacy-hero-title">Privacy Policy</h1>
          <p className="privacy-hero-subtitle">Polityka Prywatności</p>
        </div>
      </section>

      {/* Privacy Content Section */}
      <section className="privacy-content">
        <div className="privacy-content-wrapper">
          <div className="privacy-main-content">
            <div className="privacy-section">
              <h2 className="privacy-section-title">Information We Collect / Informacje, Które Zbieramy</h2>
              <div className="privacy-text">
                <p>When you use our services at Pawilon Krzyżanowskiego, we collect the following information to provide you with the best experience and process your bookings, ticket purchases, and inquiries.</p>
                <p>When purchasing event tickets, we collect your full name, email address, and phone number. For payment processing, we work with Stripe, a secure third-party payment processor that handles your credit card information in compliance with PCI DSS standards.</p>
                <p>When you contact us through our contact form, we collect your name, email, phone number, event type, preferred date, number of guests, and any message you provide.</p>
                <p>When subscribing to our newsletter, we collect your name and email address to send you updates about upcoming events at Pawilon Krzyżanowskiego.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Podczas korzystania z naszych usług w Pawilon Krzyżanowskiego zbieramy poniższe informacje, aby zapewnić Ci najlepsze doświadczenie i przetwarzać Twoje rezerwacje, zakupy biletów i zapytania.</p>
                <p style={{fontStyle: 'italic'}}>Przy zakupie biletów na wydarzenia zbieramy Twoje imię i nazwisko, adres email oraz numer telefonu. Do przetwarzania płatności wykorzystujemy Stripe, bezpiecznego zewnętrznego systemu płatności, który obsługuje Twoje dane karty kredytowej zgodnie ze standardami PCI DSS.</p>
              </div>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">How We Use Your Information / Jak Używamy Twoich Informacji</h2>
              <div className="privacy-text">
                <p>We use the information you provide to process your event ticket purchases, send you ticket confirmations and QR codes via email, and manage your bookings for private events or inquiries.</p>
                <p>Your email address is used to send you newsletters about upcoming events, special offers, and updates about Pawilon Krzyżanowskiego, but only if you have subscribed to our newsletter.</p>
                <p>We may use your contact information to respond to your inquiries, provide customer support, and manage venue bookings.</p>
                <p>Payment information is processed securely through Stripe and is never stored on our servers. Stripe handles all payment data in compliance with industry standards.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Używamy przekazanych nam informacji do przetwarzania zakupów biletów na wydarzenia, wysyłania potwierdzeń biletów i kodów QR na email oraz zarządzania Twoimi rezerwacjami na imprezy prywatne lub zapytania.</p>
              </div>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">Data Protection / Ochrona Danych</h2>
              <div className="privacy-text">
                <p>We take the security of your personal information seriously. All data is transmitted using SSL encryption, and our servers are regularly updated with the latest security patches.</p>
                <p>Your personal information is stored securely and is only accessible to authorized personnel who need it to provide our services. We do not sell, rent, or share your personal information with third parties except as necessary to process payments through Stripe or to comply with legal obligations.</p>
                <p>All customer data is stored in databases with proper access controls and regular backups. We implement industry-standard security measures to protect against unauthorized access, alteration, disclosure, or loss of your data.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Przywiązujemy dużą wagę do bezpieczeństwa Twoich danych osobowych. Wszystkie dane są przesyłane za pomocą szyfrowania SSL, a nasze serwery są regularnie aktualizowane najnowszymi poprawkami bezpieczeństwa.</p>
              </div>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">Cookies and Tracking / Ciasteczka i Śledzenie</h2>
              <div className="privacy-text">
                <p>Our website uses essential cookies to enable core functionality such as security, network management, and accessibility. These cookies are necessary for the website to function and cannot be switched off in our systems.</p>
                <p>We may use analytics cookies to understand how visitors interact with our website, which helps us improve our services and user experience. You can control cookies through your browser settings.</p>
                <p>Our payment processor Stripe may use cookies and tracking technologies as part of their service, subject to Stripe's own privacy policy.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Nasza strona internetowa wykorzystuje niezbędne ciasteczka w celu umożliwienia podstawowej funkcjonalności, takiej jak bezpieczeństwo, zarządzanie siecią i dostępność.</p>
              </div>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">Your Rights / Twoje Prawa</h2>
              <div className="privacy-text">
                <p>Under GDPR and Polish data protection laws, you have the right to access, correct, delete, or restrict the processing of your personal data. You can also withdraw your consent at any time where we rely on consent to process your data.</p>
                <p>You have the right to request a copy of the personal information we hold about you, to have any inaccuracies corrected, or to have your data deleted if it is no longer necessary for the purposes for which it was collected.</p>
                <p>You can unsubscribe from our newsletter at any time by clicking the unsubscribe link in any newsletter email you receive from us.</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Zgodnie z RODO i polskim prawem dotyczącym ochrony danych, masz prawo dostępu, sprostowania, usunięcia lub ograniczenia przetwarzania swoich danych osobowych.</p>
              </div>
            </div>

            <div className="privacy-section">
              <h2 className="privacy-section-title">Contact Us / Kontakt</h2>
              <div className="privacy-text">
                <p>If you have any questions about this Privacy Policy or wish to exercise your rights regarding your personal data, please contact us at:</p>
                <p><strong>Email:</strong> Garbary96@gmail.com<br />
                <strong>Phone:</strong> 532 883 067<br />
                <strong>Address:</strong> Ul. Garbary 96, 61-757 Poznań, Poland</p>
                <p style={{marginTop: '1rem', fontStyle: 'italic'}}>Jeśli masz pytania dotyczące tej Polityki Prywatności lub chcesz skorzystać ze swoich praw dotyczących danych osobowych, skontaktuj się z nami:</p>
              </div>
            </div>

            <div className="privacy-last-updated">
              <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Privacy;